import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";
import type { EventCategoryGroup } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

async function fetchDynamicBonusEvents(): Promise<EventCategoryGroup[]> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const response = await instance.get(API_ROUTES.DYNAMIC_BONUS_EVENTS);
  const body = bonusAdminBody<{ events: EventCategoryGroup[] }>(response);
  if (!body) {
    throw new Error("Dynamic bonus events unavailable");
  }
  return body.events;
}

export const DYNAMIC_BONUS_EVENTS_QUERY_KEY = ["DYNAMIC_BONUS_EVENTS"] as const;

export const useDynamicBonusEvents = () => {
  return useQuery<EventCategoryGroup[]>({
    queryKey: DYNAMIC_BONUS_EVENTS_QUERY_KEY,
    queryFn: fetchDynamicBonusEvents,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
};
